<template>
  <el-dialog
      custom-class="custom-dialog"
      :width="width"
      :title="title"
      :fullscreen="fullscreen"
      append-to-body
      :close-on-click-modal="clickClose"
      :destroy-on-close="closeFree"
      :visible.sync="_value"
  >
    <slot></slot>
    <!--android 确定按键-->
    <div class="button-total" slot="footer" v-if="fullscreen">
      <el-button class="left-button" @click=" _value = false;$emit('cancel');">{{ cancelText }}</el-button>
      <el-button class="right-button" @click="$emit('ok')">{{ okText }}</el-button>
    </div>
    <!--PC 确定按键-->
    <div slot="footer" v-if="fullscreen==false && showFooter">
      <el-button
          size="mini"
          @click="
          _value = false;
          $emit('cancel');
        "
      >{{ cancelText }}</el-button
      >
      <el-button size="mini" type="primary" @click="$emit('ok')">{{ okText }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "WDialog",
  install(Vue) {
    Vue.component("WDialog", this);
  },
  components: {},
  props: {
    title: {
      type: String,
      default: "",
    },
    fullscreen:{
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "50%",
    },
    value: {
      type: Boolean,
      default: false,
    },
    clickClose: {
      type: Boolean,
      default: false,
    },
    closeFree: {
      type: Boolean,
      default: false,
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
    cancelText: {
      type: String,
      default: "取 消",
    },
    okText: {
      type: String,
      default: "确 定",
    },
    border: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="less" scoped>
/deep/ .custom-dialog {
  .el-dialog__header {
    padding: 10px 20px;
    .el-dialog__title {
      font-size: 17px;
    }
    .el-dialog__headerbtn {
      top: 15px;
      .i {
        font-size: large;
      }
    }
  }

  .el-dialog__footer {
    padding: 10px 20px;
  }
}

.border {
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #e8e8e8;
  }
  /deep/ .el-dialog__footer {
    border-top: 1px solid #e8e8e8;
  }
}
.left-button{
  background-color: #D4D7DE;
  padding: 16px 40px;
  color: white;
  border-radius: 14px 0 0 14px;
  margin: 0;
  border: none;
  font-size: 12px;
  font-weight: bold;
}
.right-button{
  background-color: #409EFF;
  padding: 16px 40px;
  color: white;
  border-radius: 0 14px 14px 0;
  border: none;
  margin: 0;
  font-size: 12px;
  font-weight: bold;
}
.button-total{
  display: flex;
  justify-content: center;
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform:translateX(-50%);
}
</style>
